export class BasicInformationDTO {
  id: number;
  userTin : string ;
  returnSchemeType: string ;
  assessmentYear: string ;
  incomeYearFrom: string ;
  incomeYearTo: string ;
  anyIncome: boolean ;
  residentStatus: string;
  incomeSourceLocation: string ;
  isGazettedFreedomFighter: boolean;
  gazetteNo: string ;
  isDisabledPerson: boolean ;
  referenceNo: string ;
  referenceDate: string ;
  hasClaimBenefit: boolean ;
  childName: string ;
  disabilityReferenceNo: string ;
  disabilityReferenceDate: string ;
  haveTaxRebate: boolean ;
  isIncomeExceed4Lacks: boolean ;
  isShareholderOfCompany: boolean ;
  isGrossWealthExceed4Lacks: boolean ;
  hasOwnMotorCar: boolean ;
  haveHousePropertyAnyCity: boolean ;
  isIT10Bnotmandatorywantsubmit: boolean ;
  amountGrossWealth: string ;
}
